import NotFoundRoute from "PFApp/routes/not_found_route";
import { WithLayout } from "PFApp/routes/route_helpers";
import { EnsureProfilePermission } from "PFApp/routes/route_helpers";
import { admin } from "PFCore/base/page_layouts";
import { PermissionsGroupEditController } from "PFModules/admin/permissions_groups/edit/permissions_group_edit_controller";
import { PermissionsGroupsPage } from "PFModules/admin/permissions_groups/list/permissions_groups_page";
import { PermissionRule } from "PFTypes";
import React from "react";
import { Route, Switch, useRouteMatch } from "react-router-dom";

const PermissionsGroupRoutes = () => {
  const { path } = useRouteMatch();

  return (
    <EnsureProfilePermission permittedTo={PermissionRule.PermissionsGroupsManagement} redirectTo="/admin">
      <WithLayout layout={{ sidebar: admin }}>
        <Switch>
          <Route exact path={path}>
            <PermissionsGroupsPage />
          </Route>
          <Route exact path={`${path}/new`}>
            <PermissionsGroupEditController />
          </Route>
          <Route exact path={`${path}/:id/edit`}>
            <PermissionsGroupEditController />
          </Route>
          <Route path="*">
            <NotFoundRoute />
          </Route>
        </Switch>
      </WithLayout>
    </EnsureProfilePermission>
  );
};

export default PermissionsGroupRoutes;
